// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"109":"f80d30a4","497":"b2efc6e2","787":"d5c1046c","792":"26bbe77a","804":"5009b528"}[chunkId] + ".chunk.js";
};